// extracted by mini-css-extract-plugin
export default {"caption":"caption-module--caption--gvPk1"};